// extracted by mini-css-extract-plugin
export default {"tooltip":"eTMpNc","fadein":"MPU7pN","tooltipAfter":"MSMAys","tooltipBefore":"Czpsnr"};